import { render } from "./KobiViewTemplateTag.vue?vue&type=template&id=59bb4222"
import script from "./KobiViewTemplateTag.vue?vue&type=script&lang=js"
export * from "./KobiViewTemplateTag.vue?vue&type=script&lang=js"
script.render = render

export default script